import {
  CERT_ENTITLEMENT_VALUEKEY,
  EO_ROW_TYPE,
  LINEITEM_TYPES,
  SORT_WARN_MSGS,
} from './constants';

// eslint-disable-next-line import/prefer-default-export
export const checkParentUserExist = (data) => {
  let parentInfo = [];

  data?.forEach((ele) => {
    if (ele.isParent) {
      parentInfo.push(ele.label);
    } else if (ele.options && ele.options?.length > 0) {
      const info = checkParentUserExist(ele.options);

      parentInfo = [...info, ...parentInfo];
    }
  });

  return parentInfo;
};

export const sortedList = (list, option) => {
  if (option) {
    const index = list.findIndex((obj) => obj.label === option.label);

    if (index > -1) {
      list.splice(index, 1);
      list.unshift(option);
    }
  }

  return list;
};

export const checkDateStringExist = (string) => {
  const pattern = /\b(?:date|Date)\b/;

  return pattern.test(string);
};

export const getColumnNameIdOrWarnMessage = (
  selectedRowsArray,
  isSAOrAOCampaign,
  getWarnLabel
) => {
  const array = [...selectedRowsArray];

  if (array.length === 1) {
    return array[0];
  }

  if (!isSAOrAOCampaign) {
    if (array.includes('-4')) {
      return '-4';
    }

    if (!array.includes('-4') && array.includes('-2') && array.includes('0')) {
      if (getWarnLabel) {
        return SORT_WARN_MSGS.ROLES_AND_ACCOUNTS;
      }

      return null;
    }
  }

  if (array.length === 2 && array.includes('-2') && array.includes('>0')) {
    if (getWarnLabel) {
      return SORT_WARN_MSGS.ROLES_AND_ENTITLEMENTS;
    }

    return null;
  }

  if (array.includes('0')) {
    return '0';
  }

  return null;
};

export const getRowSelectionName = (lineItemValue) => {
  switch (lineItemValue) {
    case CERT_ENTITLEMENT_VALUEKEY.USER:
      return LINEITEM_TYPES.USER;
    case CERT_ENTITLEMENT_VALUEKEY.ACCOUNT:
      return LINEITEM_TYPES.ACCOUNT;
    case CERT_ENTITLEMENT_VALUEKEY.ROLE:
      return LINEITEM_TYPES.ROLE;
    case CERT_ENTITLEMENT_VALUEKEY.ENTITLEMENT:
      return LINEITEM_TYPES.ENTITLEMENT;
    default:
      return CERT_ENTITLEMENT_VALUEKEY.USER;
  }
};

export const getEOColumnNameIdOrWarnMessage = (
  selectedRowsArray,
  getWarnLabel
) => {
  const array = [...selectedRowsArray];

  if (array.length > 0 && !array.includes('0')) {
    if (getWarnLabel) {
      return SORT_WARN_MSGS.EO_SORT_DISABLED;
    }

    return null;
  }

  if (array.length === 1) {
    return array[0];
  }

  if (array.includes('0')) {
    return '0';
  }

  // enable in next release when child lineitems supports sort
  // if (array.includes('1')) {
  //   return '1';
  // }

  return null;
};

export const getEORowSelectionName = (lineItemValue) => {
  switch (lineItemValue) {
    case EO_ROW_TYPE.ENTITLEMENT:
      return LINEITEM_TYPES.ENTITLEMENT;
    case EO_ROW_TYPE.ACCOUNT:
      return LINEITEM_TYPES.ACCOUNT;
    case EO_ROW_TYPE['CHILD ENTITLEMENT']:
      return LINEITEM_TYPES['CHILD ENTITLEMENT'];
    default:
      return LINEITEM_TYPES.ENTITLEMENT;
  }
};
